import { render, staticRenderFns } from "./BiodataAlamat.vue?vue&type=template&id=69a9b8e7&"
import script from "./BiodataAlamat.vue?vue&type=script&lang=js&"
export * from "./BiodataAlamat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports